import React, {useMemo, useState} from 'react';
import {ICorrectionWayPointSingleVoyage} from "@containers/singleVoyage/types/point";
import {LatLng, LeafletEvent, LeafletMouseEvent} from "leaflet";
import {buildDraggableWaypointIcon} from "@ui/leafletCustom/leafletPolyline/polylineDraggable/helpers/buildIcon";
import LeafletMarker from "@ui/leafletCustom/leafletMarker/LeafletMarker";
import {
    onDragEndMarkerCorrectionPointsSingleVoyage,
    onRemoveMarkerCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";
import {useDebounce} from "@hooks/debounce/useDebounce";
import useIsFirstRender from "@hooks/useIsFirstRender";


interface IProps {
    point: ICorrectionWayPointSingleVoyage,
    onDragEndMarker: onDragEndMarkerCorrectionPointsSingleVoyage,
    onRemoveMarker: onRemoveMarkerCorrectionPointsSingleVoyage,
    index:number
}


const MarkerItemDraggableCorrectionPointsSingleVoyage = ({
                                                             point,
                                                             onRemoveMarker,
                                                             onDragEndMarker,
                                                             index,
                                                         }: IProps) => {
    const [latLng, setLatLng] = useState<LatLng>(new LatLng(point?.lat, point?.lng));
    const isFirstRender = useIsFirstRender()
    useDebounce({
        value: latLng,
        callback: (newLatLng) => {
            if (isFirstRender) {
                return
            }
            onDragEndMarker({
                point,
                latLng: [newLatLng?.lat, newLatLng?.lng],
            })
        },
        delay: 300
    })
    const eventHandlersNewMarker = useMemo(() => ({
        dragend(event: LeafletEvent) {
            const newLatLng = event.target.getLatLng()
            setLatLng(new LatLng(newLatLng?.lat, newLatLng.lng))
            onDragEndMarker({
                point,
                latLng: [newLatLng?.lat, newLatLng?.lng],
            })
        },
        drag(event: LeafletEvent) {
            const newLatLng = event.target.getLatLng()
            setLatLng(new LatLng(newLatLng?.lat, newLatLng?.lng))
        },
        click(event: LeafletMouseEvent) {
            if (!onRemoveMarker) {
                return
            }
            onRemoveMarker(point)
        }
    }), [onDragEndMarker, onRemoveMarker])


    const icon = useMemo(() => {
        return buildDraggableWaypointIcon({
            showMarkerPointNumber: true,
            pointIndex: index
        })
    }, [index])


    return (
        <LeafletMarker
            position={latLng}
            icon={icon}
            draggable
            eventHandlers={eventHandlersNewMarker}
        />
    );
};

export default MarkerItemDraggableCorrectionPointsSingleVoyage;